<form class="k-form k-form-horizontal" style="max-width: 800px;width: 800px;" [formGroup]="editForm">
  <kendo-grid #grid [data]="gridData" (cellClick)="cellClickHandler($event)" (cellClose)="cellCloseHandler($event)">
    <!-- <kendo-grid-checkbox-column      [width]="40"  [showSelectAll]="true"> </kendo-grid-checkbox-column> -->
    <kendo-grid-column field="nomeTipoFerramenta" [width]="100" [editable]="false"
      [title]="customMsgService.translate('tooltype')"> </kendo-grid-column>

    <kendo-grid-column field="numeroDeFerramentasDoTipo" [width]="100" [editable]="false"
      [title]="customMsgService.translate('totalFerramentas')"> </kendo-grid-column>

    <kendo-grid-column field="numeroDeFerramentasDoTipoDisponiveis" [width]="150" [editable]="false"
      [title]="customMsgService.translate('ferramentasIndisponiveis')"> </kendo-grid-column>

    <kendo-grid-column field="numeroDeFerramentasAutorizadas"
      [title]="customMsgService.translate('ferramentasAutorizadas')" [width]="140" editor="numeric">
      <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
        <span>{{this.customMsgService.translate('ferramentasAutorizadas')}} </span>
        <button kendoButton icon="pencil" (click)="InfoButton()"></button>
      </ng-template>
    </kendo-grid-column>

  </kendo-grid>
  <div class="k-form-buttons">
    <button kendoButton [primary]="true" (click)="saveChanges()">
      {{ customMsgService.translate('saveChanges') }}
    </button>
  </div>
</form>